import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import VueRouter from 'vue-router'
import vco from 'v-click-outside'
import vueWavesEffect from 'vue-waves-effect'
import 'vue-waves-effect/dist/vueWavesEffect.css'
import '@mdi/font/css/materialdesignicons.css'
import '@utils/vee-validate'

import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import moment from 'moment'
import i18n from './i18n'

import VueI18n from 'vue-i18n'
import 'devextreme/dist/css/dx.light.css'
Vue.use(VueI18n)

Vue.use(VueRouter)
Vue.use(vco)
Vue.use(vueWavesEffect)
Vue.prototype.moment = moment

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)

// Uncomment this if you are having api served through other url
Vue.prototype.$http = require('axios')

// set API endpoint
Vue.prototype.$http.defaults.baseURL = 'http://localhost' // 'http://103.56.149.87'

const app = new Vue({
  // components: { App },
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
